export const CAMERA_SET_GRID = 'CAMERA_SET_GRID';
export const CAMERA_SET_DATA = 'CAMERA_SET_DATA';
export const CAMERA_SET_DATA_ALL = 'CAMERA_SET_DATA_ALL';
export const CAMERA_SET_LAST_PAGE = 'CAMERA_SET_LAST_PAGE';
export const CAMERA_SET_TOTAL_ROWS = 'CAMERA_SET_TOTAL_ROWS';
export const CAMERA_SET_CURRENT_ROW = 'CAMERA_SET_CURRENT_ROW';
export const CAMERA_SET_RELOAD_DATA = 'CAMERA_SET_RELOAD_DATA';
export const CAMERA_SET_LOADING = 'CAMERA_SET_LOADING';
export const CAMERA_SET_LOADING_ALL = 'CAMERA_SET_LOADING_ALL';
export const CAMERA_TOGGLE_CREATE_EDIT_MODAL =
  'CAMERA_TOGGLE_CREATE_EDIT_MODAL';
export const CAMERA_TOGGLE_DELETE_MODAL = 'CAMERA_TOGGLE_DELETE_MODAL';
export const CAMERA_SET_MQTT_CAMERAS_STATUS = 'CAMERA_SET_MQTT_CAMERAS_STATUS';
